import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MatrixFeature {
  name: string;
  basic: boolean;
  professional: boolean;
  enterprise: boolean;
}

interface ComparisonMatrixProps {
  features: MatrixFeature[];
}

const ComparisonMatrix = ({ features }: ComparisonMatrixProps) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-card">
            <th className="text-left p-4 font-display font-bold text-foreground border-b border-border">
              Features
            </th>
            <th className="text-center p-4 font-display font-bold text-foreground border-b border-border">
              Basic
            </th>
            <th className="text-center p-4 font-display font-bold text-foreground border-b border-border">
              Professional
            </th>
            <th className="text-center p-4 font-display font-bold text-foreground border-b border-border">
              Enterprise
            </th>
          </tr>
        </thead>
        <tbody>
          {features.map((feature, index) => (
            <tr key={index} className="hover:bg-muted/50 transition-colors duration-300 ease-brand">
              <td className="p-4 text-sm text-foreground border-b border-border">{feature.name}</td>
              <td className="p-4 text-center border-b border-border">
                {feature.basic ? (
                  <Icon name="CheckIcon" size={20} className="text-success mx-auto" />
                ) : (
                  <Icon name="XMarkIcon" size={20} className="text-error mx-auto" />
                )}
              </td>
              <td className="p-4 text-center border-b border-border">
                {feature.professional ? (
                  <Icon name="CheckIcon" size={20} className="text-success mx-auto" />
                ) : (
                  <Icon name="XMarkIcon" size={20} className="text-error mx-auto" />
                )}
              </td>
              <td className="p-4 text-center border-b border-border">
                {feature.enterprise ? (
                  <Icon name="CheckIcon" size={20} className="text-success mx-auto" />
                ) : (
                  <Icon name="XMarkIcon" size={20} className="text-error mx-auto" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonMatrix;